import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(landing)/demo/DemoClient.tsx");
